import React from 'react';
import { Box } from '@mui/material';
import chatBot from '../../Chatbot.svg';

const ChatBox = ({ onClickCallback }) => {
  const handleClick = () => {
    if (onClickCallback) {
      onClickCallback();
    }
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        right: 0,
        margin: '8px',
        cursor: 'pointer'
      }}
      onClick={handleClick}
    >
      <img src={chatBot} alt="" />
    </Box>
  );
};

export default ChatBox;
